import { render, staticRenderFns } from "./UpsellCompanion.vue?vue&type=template&id=ca8b5476&"
import script from "./UpsellCompanion.vue?vue&type=script&lang=js&"
export * from "./UpsellCompanion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports